import { render, staticRenderFns } from "./CarouselDot.vue?vue&type=template&id=15d8af5c&"
import script from "./CarouselDot.vue?vue&type=script&lang=js&"
export * from "./CarouselDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports